<button type="button" class="social-btn" (click)="btnClick.emit()">
  <img class="apple-icon" [src]="isDark() ? 'assets/icons/apple-icon-dark.svg' : 'assets/icons/apple-icon.svg'" alt="Apple" />
  {{ label() }}
</button>
